module.exports = __webpack_public_path__ + "6918b597650dc62a0e21432220c89652.png";